import { PhoneOutgoing } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const OutboundCallNode = ({
  data,
  selected,
}: {
  data: { label: string };
  selected?: boolean;
}) => (
  <NodeShell
    type="outbound_call"
    icon={<PhoneOutgoing size={16} />}
    label={data.label}
    selected={selected}
  />
);
